import ProjectsContent from "./ProjectsContent/ProjectsContent"
import classes from './Projects.module.scss'

const Projects = () => {
    return (
        <div className={classes.projectsContainer}>
            <ProjectsContent />
        </div>
    )
}

export default Projects